import { useRender } from '@base-ui/react/use-render';
import clsx from 'clsx';

type BleedProps = {
  bottom?: boolean;
  className?: string;
  horizontal?: boolean;
  mobileOnly?: boolean;
  padded?: boolean;
  render?: useRender.RenderProp;
  top?: boolean;
  vertical?: boolean;
} & useRender.ComponentProps<'div'>;

export function Bleed({
  bottom = false,
  className,
  horizontal = false,
  mobileOnly = false,
  padded = true,
  render,
  top = false,
  vertical = false,
  ...rest
}: BleedProps) {
  return useRender({
    defaultTagName: 'div',
    render,
    props: {
      ...rest,
      className: clsx(
        horizontal && ['-mx-(--gutter-x,0)', mobileOnly && 'sm:mx-0'],

        (top || vertical) && ['-mt-(--gutter-y,0)', mobileOnly && 'sm:mt-0'],
        (bottom || vertical) && ['-mb-(--gutter-y,0)', mobileOnly && 'sm:mb-0'],

        padded && [
          horizontal && ['px-(--gutter-x,0)', mobileOnly && 'sm:px-0'],

          (top || vertical) && ['pt-(--gutter-y,0)', mobileOnly && 'sm:pt-0'],
          (bottom || vertical) && ['pb-(--gutter-y,0)', mobileOnly && 'sm:pb-0']
        ],

        className
      )
    }
  });
}
